import { render, staticRenderFns } from "./VehicleHeadlightTypeCard.vue?vue&type=template&id=38af3738&scoped=true"
import script from "./VehicleHeadlightTypeCard.vue?vue&type=script&lang=js"
export * from "./VehicleHeadlightTypeCard.vue?vue&type=script&lang=js"
import style0 from "./VehicleHeadlightTypeCard.vue?vue&type=style&index=0&id=38af3738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38af3738",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VehicleBulbsPreview: require('/app/components/VehicleBulbsPreview.vue').default,VehicleHeadlightHeroCard: require('/app/components/VehicleHeadlightHeroCard.vue').default,VehicleHeadlightHeroPinButton: require('/app/components/VehicleHeadlightHeroPinButton.vue').default,ProductDisplayModeToggle: require('/app/components/ProductDisplayModeToggle.vue').default,VehicleBulbFilters: require('/app/components/VehicleBulbFilters.vue').default,VehicleHeadlightExclusionButton: require('/app/components/VehicleHeadlightExclusionButton.vue').default,VehicleBulbListItem: require('/app/components/VehicleBulbListItem.vue').default,ProductListItem: require('/app/components/ProductListItem.vue').default,VehicleHeadlightExcludedProducts: require('/app/components/VehicleHeadlightExcludedProducts.vue').default})
